var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"pay-plan-lifecycle-badge",class:`pay-plan-lifecycle-badge--${_setup.variantKey}`},[(_setup.variantKey === 'terminated' && !_vm.label)?_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("✕")]):_vm._e(),_vm._v(" "+_vm._s(_setup.displayLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }